var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React, { memo, useCallback, useMemo } from 'react';
import { styled } from '@web/theme';
import { useFirebase } from '@web/firebase';
import { usePages } from '../../../ModulePage';
import { Button } from '../../../Button';
export var DeleteButton = memo(function (_a) {
    var id = _a.id;
    var deleteBlock = useFirebase().deleteBlock;
    var list = usePages().pages.list;
    var onDeleteBlock = useCallback(function () {
        deleteBlock({ _id: id });
    }, [id, deleteBlock]);
    var isAssigned = useMemo(function () {
        var isUsed = false;
        Object.values(list).forEach(function (page) {
            if (page.blocks)
                Object.values(page.blocks).forEach(function (section) {
                    if (section.includes(id)) {
                        isUsed = true;
                    }
                });
        });
        return isUsed;
    }, [list, id]);
    return (React.createElement(Delete, { onClick: onDeleteBlock, icon: "trash", disabled: isAssigned }));
});
var Delete = styled(Button)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  border-radius: 4rem;\n  background: transparent;\n  display: flex;\n  color: ", ";\n  margin-left: auto;\n  \n  &:disabled {\n\tbackground: transparent;\n  }\n"], ["\n  border-radius: 4rem;\n  background: transparent;\n  display: flex;\n  color: ", ";\n  margin-left: auto;\n  \n  &:disabled {\n\tbackground: transparent;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.error.bg;
});
var templateObject_1;
